import { useContext, useEffect, useState } from 'react'
import Toast from './layout/Toast'
import magicLinkAPI from '../services/magicLink'
import useSession from '../hooks/useSession';
import { ErrorContext } from '../context/ErrorContext';
import settingAPI from '../services/setting';


const MagicLink = () => {
    const baseUrl = 'https://spotify.bunnystudio.com/invitation'
    const [hasDefault, setHasDefault] = useState(false); 
    const [messages, setMessages] = useState([]); 
    const [settings, setSettings] = useState([]); 
    const [invited, setInvited] = useState(false);
    const [session] = useSession()
    const [error, setError] = useState([])
    const { parseErrors } = useContext(ErrorContext)
    const [formData, setFormData] = useState({
        email_guest: '',
        opportunity_code: '',
        fulfillment: '',
    });
    const {
        email_guest,
        opportunity_code,
        fulfillment,
    } = formData;
    const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value })
    const onSubmit = async (e) => {
        e.preventDefault()
        await createMagicLink(true);
        setInvited(true)
        setFormData({
            email_guest: '',
            opportunity_code: '',
            fulfillment: '',
        })
    }
    const onCopy = async (e) => {
        e.preventDefault()
        const link = await createMagicLink();
        navigator.clipboard.writeText(link);
        setMessages([{
            message: 'Link copied to clipboard'
        }])
        setFormData({
            email_guest: '',
            opportunity_code: '',
            fulfillment: '',
        })
        clearForm()
    }

    const clearForm = () => {
        for(let key of Object.keys(formData)) {
            const element = document.getElementById(key)
            if (element) element.value = null
        }
    }

    const createMagicLink = async (mailed = false) => {
        setError([]);
        try {
            const payload = {...formData, send_email: mailed}
            const res = await magicLinkAPI.post({ payload: payload, jwt: session })
            const code = res.data.data.hash_id_magic_link
            const fulfillment = res.data.data.fulfillment
            const link = baseUrl+'/'+code
            return link
        } catch (err) {
            const parsedErr = parseErrors(err.response.data.errors)
            setError(parsedErr)
        }
    }

    const onNewProject = (e) => {
        e.preventDefault()
        setInvited(false)
    }

    useEffect(() => {
        (async () => {
            try {
                const settings = await settingAPI.get()
                setSettings(settings.data.data)
                checkInitialSettings(settings.data.data)
            } catch (error) {
                console.error(error)
            }
        })()
    }, [])

    const checkInitialSettings = (list) => {
        const enabledStts = list.filter(stt => stt.enabled == 1)

        if (enabledStts.length == 1) {
            console.log(enabledStts[0].abbreviation)
            switch (enabledStts[0].abbreviation) {
                case 'AC-CON':
                    setFormData({ ...formData, fulfillment: "contest" })
                    break
                case 'AC-SP':
                    setFormData({ ...formData, fulfillment: "speedy" })
                    break
            }
            setHasDefault(true)
        }
    }

    const checkSettings = (setting) => {
        const filterSettings = settings.filter((item) => item.abbreviation == setting)
        return filterSettings && filterSettings.length && filterSettings[0].enabled ? true : false
    }

    return (
        <>
            {!invited ?
                <div className="w-1/2 m-auto my-10 text-[#152536]">
                    <h1 className='font-bold text-[40px] leading-[60px] text-center'>Invite to new project</h1>
                    <p className='font-normal text-[#68717A] my-12'>Once authorized, create a new project inviting your client via email or link.</p>
                    <form className='my-12 text-base' onSubmit={e => onSubmit(e)}>
                        <div className='mb-4'>
                            <label htmlFor="email_guest" className='block font-semibold'>Client’s email</label>
                            <input id="email_guest"
                                className='block w-full h-9 my-2 px-[12px] py-[6px] border border-solid border-[#B6B7C0] rounded'
                                type="email"
                                placeholder="someone@email.com"
                                onChange={e => onChange(e)}
                                name="email_guest"
                                required
                            />
                            <p className='text-xs text-[#6D7081]'>This user will be able to approve or reject the project and request changes.</p>
                        </div>
                        <div className='mb-4'>
                            <label htmlFor="opportunity_code" className='block font-semibold'>Opportunity code</label>
                            <input id="opportunity_code"
                                className='block w-full h-9 my-2 px-[12px] py-[6px] border border-solid border-[#B6B7C0] rounded'
                                onChange={e => onChange(e)}
                                placeholder="ABCDEFG"
                                name="opportunity_code"
                            />
                        </div>
                        {!hasDefault ? <div className='mb-4'>
                            <label className='block font-semibold'>Fulfillment type</label>
                            <div className='flex justify-between text-[#3D3F4B] text-base my-4'>
                                {checkSettings('AC-CON') ? <div className='flex'>
                                    <div className="flex items-center h-5">
                                        <input id='contest-option' type="radio" value="contest" name="fulfillment" checked={formData.fulfillment === "contest"} onChange={e => onChange(e)} className='w-4 h-4 accent-[#FE8C18]' />
                                    </div>
                                    <div className="ml-2 text-sm">
                                        <label htmlFor="contest-option">Contest</label>
                                        <p id="contest-option-text" className='text-xs'>Get three auditions and choose a winner</p>
                                    </div>
                                </div> : <></>}
                                {checkSettings('AC-SP') ? <div className='flex'>
                                    <div className="flex items-center h-5">
                                        <input id='speedy-option' type="radio" value="speedy" name="fulfillment" checked={formData.fulfillment === "speedy"} onChange={e => onChange(e)} className='w-4 h-4 accent-[#FE8C18]' />
                                    </div>
                                    <div className="ml-2 text-sm">
                                        <label htmlFor="speedy-option">Speedy</label>
                                        <p id="speedy-option-text" className='text-xs'>Let us pich the best-suited talent for your project</p>
                                    </div>
                                </div> : <></>}
                            </div>
                        </div> : <></>}
                        <div className='flex gap-4 items-center my-12'>
                            <input
                                type="submit"
                                className="font-semibold text-base text-white bg-[#FE8C18] hover:bg-[#e77707] focus:ring-4 focus:ring-[#fc9d3e] px-6 py-4 rounded focus:outline-none"
                                value="Invite client"
                            />
                            <p>or</p>
                            <button type="button" onClick={(e) => onCopy(e)} className='flex gap-2 items-center font-semibold text-base text-[#FE8C18] px-6 py-4 rounded focus:outline-none border-[#FE8C18] border bg-white hover:bg-gray-100 focus:ring-4 focus:ring-gray-200'>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.53025 1.78251C10.2395 0.0732618 13.0073 0.0717306 14.7174 1.78251C16.4272 3.49161 16.4279 6.25926 14.7175 7.96973C14.1616 8.52564 13.7319 8.9559 13.3974 9.29089C13.1156 9.57305 12.9013 9.78763 12.7359 9.95276C12.5027 10.1856 12.1006 10.0263 12.0957 9.69676C12.0899 9.29846 12.0402 8.90203 11.9474 8.51464C11.9172 8.38873 11.9559 8.25623 12.0475 8.1647L13.4802 6.7322C14.5038 5.70798 14.508 4.04807 13.4802 3.0197C12.456 1.99611 10.7961 1.99198 9.76775 3.0197L7.41806 5.3697C6.39562 6.39235 6.39378 8.0576 7.41806 9.08189C7.62555 9.28976 7.86656 9.46121 8.131 9.58904C8.27546 9.65882 8.35543 9.8156 8.33603 9.97485C8.29365 10.3224 8.13931 10.6588 7.87306 10.925L7.73634 11.0617C7.62303 11.175 7.44953 11.2053 7.30634 11.1334C6.90012 10.9295 6.51925 10.6581 6.18056 10.3194C4.58396 8.72279 4.48128 6.18542 5.87587 4.47064C5.89756 4.44378 5.9155 4.4214 5.93379 4.39931C6.07998 4.22271 6.24832 4.06444 8.53025 1.78251ZM10.1241 12.5294C11.5187 10.8146 11.416 8.27723 9.81943 6.68064C9.48075 6.34195 9.09987 6.07048 8.69365 5.86661C8.55043 5.79473 8.37693 5.82498 8.26365 5.93829L8.12693 6.07501C7.86071 6.34126 7.70634 6.67761 7.66396 7.02517C7.64456 7.18442 7.72453 7.3412 7.869 7.41098C8.13342 7.53882 8.37444 7.71027 8.58193 7.91814C9.60621 8.94242 9.60437 10.6077 8.58193 11.6303L6.23225 13.9803C5.20387 15.008 3.54396 15.0039 2.51975 13.9803C1.49203 12.9519 1.49615 11.292 2.51975 10.2678L3.95253 8.83535C4.04409 8.74382 4.08278 8.61132 4.05259 8.48542C3.95983 8.09803 3.91009 7.70159 3.90428 7.30329C3.89943 6.97373 3.49731 6.81442 3.26409 7.04729C3.09874 7.21242 2.88448 7.42697 2.60273 7.7091C2.26819 8.0441 1.8385 8.47438 1.28256 9.03032C-0.427879 10.7408 -0.42716 13.5084 1.28256 15.2175C2.99268 16.9283 5.7605 16.9268 7.46975 15.2175C9.75169 12.9356 9.92002 12.7773 10.0662 12.6007C10.0845 12.5786 10.1024 12.5562 10.1241 12.5294Z" fill="#FE8C18" />
                                </svg>
                                <span>Copy link</span>
                            </button>
                        </div>
                    </form>
                </div> :
                <div className='w-1/2 m-auto my-10 text-[#152536]'>
                    <h1 className='font-bold text-[40px] leading-[60px] text-center'>Client invited</h1>
                    <p className='font-normal text-[#68717A] my-12 text-center'>The email was succesfully sent. Ask your client to check their inbox to complete the project submission.</p>
                    <div className='w-full flex justify-center'>
                        <button type="button" onClick={(e) => onNewProject(e)} className='font-semibold text-base text-white bg-[#FE8C18] hover:bg-[#e77707] focus:ring-4 focus:ring-[#fc9d3e] px-6 py-4 rounded focus:outline-none'>Create new project</button>
                    </div>
                </div>}
            <Toast toast={messages} time={3000} />
        </>
    )
}

export default MagicLink
